import * as React from 'react';

export const lightboxRef = React.createRef();

export function showLightbox(files) {
  lightboxRef.current?.showLightbox(files);
}
export function hideLightbox() {
  lightboxRef.current?.hideLightbox();
}